<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold cl-agen-dark">Bonus Transfer History</div>
		</div>
		<div class="mt-2">
			<v-row justify="center" v-if="summaryTransfer">
				<v-col cols="12" sm="5" md="4">
					<v-card class="px-3 py-5 elevation-0 rounded-xl hover-shadow">
						<v-row>
							<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
								<img class="img-fluid" src="/assets/icon/transfer-bonus-terakhir.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 cl-secondary font-weight-500">
									<div>{{ summaryTransfer.last_transfer_value | toCurrencyFormat }}</div>
								</div>
								<div class="font-size-10 cl-grey">Last Bonus Transfer</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" sm="5" md="4" class="pt-0 pt-sm-3">
					<v-card class="px-3 py-5 elevation-0 rounded-xl hover-shadow">
						<v-row>
							<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
								<img class="img-fluid" src="/assets/icon/summary-total-bonus.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 cl-secondary font-weight-500">{{ summaryTransfer.total_transfer_value | toCurrencyFormat }} </div>
								<div class="font-size-10 cl-grey">Total Bonus Transferred</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<div class="d-flex flex-wrap justify-end">
				<v-col cols="12" sm="11" md="8" class="px-0">
					<v-row justify="end" align="center">
						<v-col cols="12" sm="12" md="6" v-if="false"><label class="grey--text text--darken-2 font-size-10 d-block text-right pr-2">Show based on</label></v-col>
						<v-col cols="12" sm="12" md="8" class="d-flex flex-wrap">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Select Date Range" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-xl date-no-border" hide-details v-model="dateRangeText"></v-text-field>
								</template>
								<v-date-picker range :min="dateStart[0]" :max="nowDate" locale="en" type="date" color="primary" @change="getData" v-model="dateStart"></v-date-picker>
							</v-menu>
							<v-btn depressed color="grey lighten-1" class="ml-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</div>
			<div class="pt-3" v-if="!loading">
				<v-row v-if="listHistoryTransfer.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-history-transfer">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left" width="25%">Transfer Date</th>
										<th class="text-left" width="20%">Bank Info</th>
										<th class="text-center" width="10%">Status</th>
										<th class="text-right" width="20%">Amount</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="history in listHistoryTransfer" :key="history.bonus_withdrawal_id">
										<td class="text-left">{{ history.datetime | toDate }}</td>
										<td class="text-left py-2">
											<div class="cl-dark-green font-weight-500">{{ history.bank_name }}</div>
											<div class="cl-grey">{{ history.bank_account_no }}</div>
											<div class="">{{ history.bank_account_name }}</div>
										</td>
										<td class="text-center">
											<v-chip small class="font-weight-bold white--text text-uppercase" :color="getTransferStatus(history.status).color">{{ getTransferStatus(history.status).label }}</v-chip>
										</td>
										<td class="text-right primary--text  font-weight-bold">{{ history.total_transfer | toCurrencyFormat }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="pt-3" v-if="listHistoryTransfer.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center primary--text ">No bonus transfer history data available.</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listHistoryTransfer.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historyTransferPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Showing {{ historyTransferPagination.total_display }} data from {{ historyTransferPagination.total_data }} data</div>
						</v-col>
						<v-col cols="3" sm="2" md="1">
							<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="red darken-3" @input="changeLimit"></v-select>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="pt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
	components: {
	},
	data() {
		return {
			nowDate: new Date().toISOString().slice(0,10),
			loading: false,
			startDate: false,
			dateStart: [],  //moment().format("YYYY-MM")
			start: '',
			end: '',
			monthYear: null, //new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
			dayStart: '1',
			dayEnd: '31',
			bonusLastComission: 0,
			bonusTotalComission: 0,
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			transferStatus: [
				{
					status: 'success',
					color: 'teal lighten-2',
					label: 'Sukses',
					icon: 'mdi-check-decagram-outline'
				},
				{
					status: 'pending',
					color: 'amber',
					label: 'Pending',
					icon: 'mdi-timer-sand'
				},
				{
					status: 'failed',
					color: 'red lighten-2',
					label: 'Gagal',
					icon: 'mdi-close-circle-outline'
				}
			]
		}
	},
	computed: {
		...mapState('komisi', ['listHistoryTransfer', 'historyTransferPagination', 'summaryTransfer']),

		dateRangeText() {
			if ( this.dateStart.length > 0 ) {
				const date1 = moment(this.dateStart[0]).format("DD MMMM YYYY")
				const date2 = moment(this.dateStart[1]).format("DD MMMM YYYY")
				return date1 + '  to  ' + date2
			} 
			else return ''
		},
	},
	methods: {
		...mapActions('komisi', ['getHistoryTransfer', 'getSummaryTransfer']),

		getTransferStatus(status) {
			const transfer = this.transferStatus.find(x => x.status === status)
			if (transfer) return transfer
			else {
				const nontransfer = {
					status: '',
					color: 'secondary',
					label: '',
					icon: ''
				}
				return nontransfer
			}
		},
		printBonus(id) {
			let routeData = this.$router.resolve({name: 'bonus-statement', params : { slug: id} })
			window.open(routeData.href, '_blank');
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getData() {
			this.loading = true
			let start = ''
			let ends = ''

			if (this.dateStart.length > 0) {
				start = moment(this.dateStart[0]).format("YYYY-MM-DD")
				ends = moment(this.dateStart[1]).format("YYYY-MM-DD")
			}

			let params = [{
				type: 'date',
				field: 'datetime',
				value: start + '::' + ends,
				comparison: 'bet',
			}]

			this.startDate = false
			this.getSummaryTransfer()
			this.getHistoryTransfer(this.queryString({sort: 'datetime', dir: 'DESC', page: this.page, limit: this.limit, params: params})).then(() => {
				// this.bonusLastComission = response.results.bonus_last_comission
				// this.bonusTotalComission = response.results.bonus_total_comission
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		reset() {
			this.dateStart = []
			this.page = 1
			this.limit = '10'
			this.getData()
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Bonus Transfer History`)
		this.getData()
	}
};
</script>

